import { render, staticRenderFns } from "./NameReservationApplications.vue?vue&type=template&id=85922382&scoped=true&"
import script from "./NameReservationApplications.vue?vue&type=script&lang=js&"
export * from "./NameReservationApplications.vue?vue&type=script&lang=js&"
import style0 from "./NameReservationApplications.vue?vue&type=style&index=0&id=85922382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85922382",
  null
  
)

export default component.exports